import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 16px 24px 16px;
  border-radius: 8px;
  background: var(--primary-100, #e6f1fa);
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 20px;
`;

export const MessageContainer = styled.span`
  color: var(--primary-sanlam-blue, #0075c9);
  font-feature-settings: 'liga' off;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.25px;
  margin-left: 10px;
  vertical-align: top;
`;
